// extracted by mini-css-extract-plugin
export default {"notFoundStyle":"Notfound_notFoundStyle__QrV+a"};